







































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AlertRisiko from "../lembar-observasi-kebidanan/AlertRisiko.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import Store from "@/store/modules/ObservasiKebidananBishopStore";
import Service from "@/services/ObservasiKebidananBishop";
import { ObservasiKebidananBishop } from "@/types/ObservasiKebidananBishop";
import { KebidananAlert } from "@/types/LembarObservasiAsuhanKebidanan";
import { evaluateKebidananAlerts } from "@/utils/kebidananAlerts";
import {
  calculateTp,
  calculateUsiaKehamilan,
  calculateTbj,
  calculateImt
} from "@/utils/kebidananCalculator";
import {
  computeBishop,
  interpretasiLabel,
  BishopModifier,
  BishopResult
} from "@/utils/bishopScore";

@Component({
  components: { AlertRisiko, PersonAutoComplete },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class ObservasiKebidananBishopPage extends Vue {
  @Prop({ required: true }) registerId!: number;
  @Prop({ required: true }) pasienRm!: string;
  @Prop({ default: undefined }) unitId?: string;
  @Prop({ default: false }) isActive!: boolean;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  openPanels: number[] = [0, 4, 5];
  menuTgl = false;
  menuHpht = false;

  confirmDialog = false;
  confirmMessage = "";
  confirmAction: (() => Promise<void>) | null = null;

  // Options
  ruanganOptions = [
    { text: "VK / Bersalin", value: "vk" },
    { text: "Ponek", value: "ponek" },
    { text: "Rawat Inap Obstetri", value: "ranap_obstetri" },
    { text: "IGD", value: "igd" }
  ];
  nrOptions = ["NR", "R", "belum"];
  riwayatPersalinanOptions = ["Spontan", "SC", "VE/Forsep", "Belum pernah"];
  penyakitKronisOptions = ["HT", "DM", "Jantung", "Asma", "Tiroid"];
  keadaanUmumOptions = ["Baik", "Sedang", "Lemah"];
  proteinUrinOptions = ["Negatif", "+1", "+2", "+3", "+4"];
  leopold4Options = [
    "Konvergen (belum masuk PAP)",
    "Sejajar",
    "Divergen (sudah masuk PAP)"
  ];
  hisIntensitasOptions = [
    { text: "Kuat", value: "kuat" },
    { text: "Sedang", value: "sedang" },
    { text: "Lemah", value: "lemah" }
  ];
  konsistensiOptions = [
    { text: "Keras (Firm)", value: "firm" },
    { text: "Sedang (Medium)", value: "medium" },
    { text: "Lunak (Soft)", value: "soft" }
  ];
  posisiOptions = [
    { text: "Posterior", value: "posterior" },
    { text: "Tengah (Mid)", value: "mid" },
    { text: "Anterior", value: "anterior" }
  ];
  stationOptions = [-3, -2, -1, 0, 1, 2, 3];
  modifierOptions: { text: string; value: BishopModifier }[] = [
    { text: "Pre-eklampsia (-1)", value: "preeklampsia" },
    { text: "Post-date ≥41 mg (-1)", value: "postdate" },
    { text: "Nulipara (-1)", value: "nulipara" },
    { text: "Multipara (+1)", value: "multipara" },
    { text: "KPD (+1)", value: "kpd" },
    { text: "Riwayat pervaginam aterm (+1)", value: "riwayat_pervaginam_aterm" }
  ];

  // Form state (nested, mirror resource)
  form: ObservasiKebidananBishop = this.emptyForm();
  so = this.form.status_obstetri!;
  triple = this.so.triple_eliminasi!;
  anamnesis = this.form.anamnesis!;
  pu = this.form.pemeriksaan_umum!;
  ant = this.pu.antropometri!;
  ol = this.form.obstetri_luar!;
  his = this.ol.his!;
  vt = this.form.vt!;
  ass = this.form.assessment!;
  penunjang = this.form.penunjang!;
  modifiers: BishopModifier[] = [];

  emptyForm(): ObservasiKebidananBishop {
    const now = new Date();
    const p2 = (n: number) => String(n).padStart(2, "0");
    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.unitId,
      tgl_observasi: `${now.getFullYear()}-${p2(now.getMonth() + 1)}-${p2(now.getDate())}`,
      jam_observasi: `${p2(now.getHours())}:${p2(now.getMinutes())}`,
      ruangan: null,
      bishop_indikasi: false,
      bishop_rencana: "",
      keluhan_utama: "",
      evaluasi: "",
      status_obstetri: {
        riwayat_penyakit_kronis: [],
        triple_eliminasi: { hiv: "belum", sifilis: "belum", hbsag: "belum" }
      },
      anamnesis: {},
      pemeriksaan_umum: { gcs: {}, td: {}, antropometri: {} },
      obstetri_luar: { his: {} },
      vt: {},
      assessment: {},
      penunjang: { lab: {} }
    } as any;
  }

  get store() {
    return Store;
  }
  get loading(): boolean {
    return this.store.loading;
  }
  get record(): ObservasiKebidananBishop | null {
    return this.store.current;
  }
  get recordId(): number | undefined {
    return this.record?.id;
  }
  get bidanSigned(): boolean {
    return !!this.record?.sign?.bidan?.signed;
  }
  get koordinatorSigned(): boolean {
    return !!this.record?.sign?.koordinator?.signed;
  }
  get dpjpSigned(): boolean {
    return !!this.record?.sign?.dpjp?.signed;
  }
  get isReadonly(): boolean {
    return this.bidanSigned;
  }

  get tpDisplay(): string | null {
    return this.so.hpht ? calculateTp(this.so.hpht) : null;
  }
  get ukDisplay(): string | null {
    if (!this.so.hpht) return null;
    const uk = calculateUsiaKehamilan(this.so.hpht, this.form.tgl_observasi);
    return uk ? `${uk.minggu} mg ${uk.hari} hr` : null;
  }
  get tbjDisplay(): number | null {
    const tfu = this.ol.tfu_cm;
    if (tfu == null) return null;
    const sudahPap = (this.ol.leopold_4 || "").toLowerCase().indexOf("divergen") >= 0;
    return calculateTbj(tfu, sudahPap);
  }
  get imtDisplay(): number | null {
    return calculateImt(this.ant.bb_pra_hamil ?? null, this.ant.tb ?? null);
  }
  get gcsTotal(): number | null {
    const g = this.pu.gcs || {};
    if (g.e == null && g.v == null && g.m == null) return null;
    return (g.e || 0) + (g.v || 0) + (g.m || 0);
  }

  get bishop(): BishopResult {
    return computeBishop(
      {
        dilatasi_cm: this.vt.dilatasi_cm ?? null,
        effacement_persen: this.vt.effacement_persen ?? null,
        station: this.vt.station ?? null,
        konsistensi: this.vt.konsistensi ?? null,
        posisi: this.vt.posisi ?? null
      },
      this.modifiers
    );
  }
  get interpType(): string {
    const i = this.bishop.interpretasi;
    if (i === "favorable") return "success";
    if (i === "equivocal") return "warning";
    return "error";
  }

  get liveAlerts(): KebidananAlert[] {
    return evaluateKebidananAlerts({
      td_sistol: this.pu.td.sistol ?? null,
      td_diastol: this.pu.td.diastol ?? null,
      nadi: this.pu.nadi ?? null,
      suhu: this.pu.suhu ?? null,
      rr: this.pu.rr ?? null,
      lila: this.ant.lila ?? null,
      lab_hb: this.penunjang.lab?.hb ?? null,
      djj: this.ol.djj ?? null,
      anc_dilakukan: this.so.anc_teratur ?? null,
      anc_frekuensi: this.so.anc_frekuensi ?? null
    });
  }

  interpretasiLabel = interpretasiLabel;
  fmtSkor(v: number | null): string {
    return v == null ? "—" : String(v);
  }
  labelKonsistensi(v?: string | null): string {
    const f = this.konsistensiOptions.find(o => o.value === v);
    return f ? f.text : "—";
  }
  labelPosisi(v?: string | null): string {
    const f = this.posisiOptions.find(o => o.value === v);
    return f ? f.text : "—";
  }

  async mounted() {
    if (this.registerId) {
      await this.store.loadByRegister(this.registerId);
      this.hydrate();
    }
  }

  @Watch("isActive")
  async onActive(val: boolean) {
    if (val && this.registerId && !this.record) {
      await this.store.loadByRegister(this.registerId);
      this.hydrate();
    }
  }

  rebind() {
    this.so = this.form.status_obstetri!;
    this.triple = this.so.triple_eliminasi!;
    this.anamnesis = this.form.anamnesis!;
    this.pu = this.form.pemeriksaan_umum!;
    this.ant = this.pu.antropometri!;
    this.ol = this.form.obstetri_luar!;
    this.his = this.ol.his!;
    this.vt = this.form.vt!;
    this.ass = this.form.assessment!;
    this.penunjang = this.form.penunjang!;
  }

  hydrate() {
    const rec = this.record;
    const base = this.emptyForm();
    if (!rec) {
      this.form = base;
      this.modifiers = [];
      this.rebind();
      return;
    }
    this.form = {
      ...base,
      ...rec,
      status_obstetri: {
        ...base.status_obstetri,
        ...(rec.status_obstetri || {}),
        triple_eliminasi: {
          ...base.status_obstetri!.triple_eliminasi,
          ...((rec.status_obstetri || {}).triple_eliminasi || {})
        },
        riwayat_penyakit_kronis:
          (rec.status_obstetri || {}).riwayat_penyakit_kronis || []
      },
      anamnesis: { ...base.anamnesis, ...(rec.anamnesis || {}) },
      pemeriksaan_umum: {
        ...base.pemeriksaan_umum,
        ...(rec.pemeriksaan_umum || {}),
        gcs: { ...base.pemeriksaan_umum!.gcs, ...((rec.pemeriksaan_umum || {}).gcs || {}) },
        td: { ...base.pemeriksaan_umum!.td, ...((rec.pemeriksaan_umum || {}).td || {}) },
        antropometri: {
          ...base.pemeriksaan_umum!.antropometri,
          ...((rec.pemeriksaan_umum || {}).antropometri || {})
        }
      },
      obstetri_luar: {
        ...base.obstetri_luar,
        ...(rec.obstetri_luar || {}),
        his: { ...base.obstetri_luar!.his, ...((rec.obstetri_luar || {}).his || {}) }
      },
      vt: { ...base.vt, ...(rec.vt || {}) },
      assessment: { ...base.assessment, ...(rec.assessment || {}) },
      penunjang: {
        ...base.penunjang,
        ...(rec.penunjang || {}),
        lab: { ...base.penunjang!.lab, ...((rec.penunjang || {}).lab || {}) }
      },
      bishop_indikasi: rec.bishop?.indikasi ?? false,
      bishop_rencana: rec.bishop?.rencana ?? ""
    } as ObservasiKebidananBishop;
    this.modifiers = (rec.bishop?.modifiers as BishopModifier[]) || [];
    this.rebind();
  }

  flatten(): Record<string, any> {
    const hhmm = (s: unknown) =>
      typeof s === "string" && s.length >= 5 ? s.slice(0, 5) : s || null;
    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.unitId,
      tgl_observasi: this.form.tgl_observasi,
      jam_observasi: hhmm(this.form.jam_observasi),
      ruangan: this.form.ruangan,

      // A
      gravida: this.so.gravida,
      para: this.so.para,
      abortus: this.so.abortus,
      hpht: this.so.hpht || null,
      riwayat_persalinan: this.so.riwayat_persalinan,
      anc_teratur: this.so.anc_teratur,
      anc_frekuensi: this.so.anc_frekuensi,
      triple_hiv: this.triple.hiv,
      triple_sifilis: this.triple.sifilis,
      triple_hbsag: this.triple.hbsag,
      gol_darah: this.so.gol_darah,
      rhesus: this.so.rhesus,
      riwayat_penyakit_kronis: this.so.riwayat_penyakit_kronis,
      riwayat_alergi: this.so.riwayat_alergi,

      // B
      keluhan_utama: this.form.keluhan_utama,
      anamnesis: { ...this.anamnesis },

      // C
      keadaan_umum: this.pu.keadaan_umum,
      gcs_e: this.pu.gcs?.e,
      gcs_v: this.pu.gcs?.v,
      gcs_m: this.pu.gcs?.m,
      td_sistol: this.pu.td?.sistol,
      td_diastol: this.pu.td?.diastol,
      nadi: this.pu.nadi,
      rr: this.pu.rr,
      suhu: this.pu.suhu,
      spo2: this.pu.spo2,
      nyeri_nrs: this.pu.nyeri_nrs,
      bb_pra_hamil: this.ant.bb_pra_hamil,
      bb_saat_ini: this.ant.bb_saat_ini,
      tb: this.ant.tb,
      lila: this.ant.lila,
      edema: this.pu.edema,
      protein_urin: this.pu.protein_urin,

      // D
      leopold_1: this.ol.leopold_1,
      leopold_2: this.ol.leopold_2,
      leopold_3: this.ol.leopold_3,
      leopold_4: this.ol.leopold_4,
      tfu_cm: this.ol.tfu_cm,
      djj: this.ol.djj,
      djj_irama: this.ol.djj_irama,
      his_frekuensi: this.his.frekuensi,
      his_durasi_detik: this.his.durasi_detik,
      his_intensitas: this.his.intensitas,

      // E (VT)
      vt_jam: hhmm(this.vt.jam),
      vt_operator: this.vt.operator,
      vt_vulva_vagina: this.vt.vulva_vagina,
      vt_dilatasi_cm: this.vt.dilatasi_cm,
      vt_effacement_persen: this.vt.effacement_persen,
      vt_konsistensi: this.vt.konsistensi,
      vt_posisi: this.vt.posisi,
      vt_station: this.vt.station,
      vt_ketuban: this.vt.ketuban,
      vt_presentasi: this.vt.presentasi,
      vt_molase: this.vt.molase,
      vt_denominator: this.vt.denominator,
      vt_bagian_kecil: this.vt.bagian_kecil,
      vt_panggul: this.vt.panggul,

      // F (Bishop — hanya indikasi/modifier/rencana; skor dihitung server)
      bishop_indikasi: this.form.bishop_indikasi,
      bishop_modifiers: this.modifiers,
      bishop_rencana: this.form.bishop_rencana,

      // G
      penunjang: { ...this.penunjang },

      // H
      diagnosis_ibu: this.ass.diagnosis_ibu,
      diagnosis_ibu_icd10: this.ass.diagnosis_ibu_icd10,
      diagnosis_janin: this.ass.diagnosis_janin,
      masalah_risiko: this.ass.masalah_risiko,

      // I
      evaluasi: this.form.evaluasi
    };
  }

  async save() {
    if (this.readOnly) return;
    try {
      await this.store.save(this.flatten());
      this.hydrate();
    } catch (e) {
      /* error alert handled in service */
    }
  }

  openConfirm(message: string, action: () => Promise<void>) {
    this.confirmMessage = message;
    this.confirmAction = action;
    this.confirmDialog = true;
  }
  async runConfirm() {
    const a = this.confirmAction;
    this.confirmDialog = false;
    if (a) await a();
    this.confirmAction = null;
  }

  signBidan() {
    this.openConfirm("TTD Bidan Pelaksana akan mengunci form. Lanjutkan?", async () => {
      await this.store.signBidan();
      this.hydrate();
    });
  }
  signKoordinator() {
    this.openConfirm("TTD Bidan Koordinator. Lanjutkan?", async () => {
      await this.store.signKoordinator();
      this.hydrate();
    });
  }
  signDpjp() {
    this.openConfirm("TTD DPJP Obgyn akan memverifikasi form. Lanjutkan?", async () => {
      await this.store.signDpjp();
      this.hydrate();
    });
  }

  printPdf() {
    if (!this.recordId) return;
    window.open(Service.pdfUrl(this.recordId), "_blank");
  }
}
